import { getAction, postAction, deleteAction } from '@/api/manage'

const baseUrl = '/online/exportCenter'

// 提交异步导出任务(立即返回)
export const createExportTask = (params) => postAction(baseUrl + '/create', params)
// 分页查询当前租户导出任务(轮询同一接口)
export const listExportTasks = (params) => getAction(baseUrl + '/list', params)
// 当前租户进行中任务数(角标)
export const countActiveTasks = (params) => getAction(baseUrl + '/count', params)
// 取消/终止导出任务(排队中或生成中)
export const cancelExportTask = (id) => postAction(baseUrl + '/cancel?id=' + id)
// 删除导出任务(同时清理后台文件)
export const deleteExportTask = (id) => deleteAction(baseUrl + '/' + id)
